import { graphql, useStaticQuery } from 'gatsby';

export function useOfficesCount() {
  const {
    allOffice: { totalCount },
  } = useStaticQuery(graphql`
    query {
      allOffice {
        totalCount
      }
    }
  `);
  return totalCount;
}
